import { render, staticRenderFns } from "./MenuSide.vue?vue&type=template&id=c1b749b2&"
import script from "./MenuSide.vue?vue&type=script&lang=js&"
export * from "./MenuSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports